import { has } from 'lodash-es';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'pship-columns-slider'
})
export class ColumnsSliderComponent extends Vue {
  @Prop({
    type: [Number, String]
  })
  active: number | string;

  @Prop({
    default: () => [],
    type: Array
  })
  columns: { group?: number }[];

  @Prop({
    default: () => true,
    type: [Boolean, String]
  })
  gradient: boolean;

  get groups() {
    return this.columns.map((column, idx) =>
      has(column, 'group') ? column : { group: idx }
    );
  }

  handlerGroupChange(index: number) {
    this.$emit('change', index);
  }
}
